export function createFileLink(file, reference, type) {
  const newBlob = new Blob([file], { type });
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }
  const data = window.URL.createObjectURL(newBlob);
  const link = document.createElement('a');
  link.href = data;
  link.download = reference + '.' + (type === 'text/pdf' ? 'pdf' : 'xlsx');
  link.dispatchEvent(
    new MouseEvent('click', { bubbles: true, cancelable: true, view: window }),
  );
  setTimeout(() => {
    window.URL.revokeObjectURL(data);
    link.remove();
  }, 100);
}

export const RESEARCH_METHODS = {
  address: 'Address',
  coordinates: 'Coordinates',
  noa: 'Building',
  id_bts_noa: 'Building',
  id_bts_building: 'Building',
  building: 'Building',
  id_building: 'Building',
  pop: 'Building',
  pfs: 'Building',
  roe: 'Building',
  cno: 'Building',
  pozzetto: 'Building',
  poi: 'Building',
  school: 'Building',
  healthcare: 'Building',
  id_school: 'Building',
  id_healthcare: 'Building',
  import: 'Inserimento massivo',
  point: 'Address'
}

export const REQUEST_TYPES = {
  coordinates: 'GEOGRAPHIC COORDINATES',
  noa: 'NOA',
  pop: 'POP',
  pfs: 'PFS',
  roe: 'ROE',
  cno: 'CNO',
  pozzetto: 'POZZETTO',
  poi: 'POI',
  school: 'SCHOOL',
  healthcare: 'HEALTHCARE',
  building: 'BUILDING',
  point: 'ADDRESS',
  address: 'ADDRESS',
  bts_building: 'BTS',
  bts_noa: 'BTS'
}

export const switchValues = {
  'building': 'id_building',
  'point': 'address',
  'noa': 'id_bts_noa',
  'bts_noa': 'id_bts_noa',
  'bts_building': 'id_bts_building',
  'school': 'id_school',
  'healthcare': 'id_healthcare',
  'punti_intermedi': 'punti_intermedi',
  'pop_pcn_xpop': 'pop_pcn_xpop',
}

export const inputNamesVariables = [
  'B-END',
  'A-END1',
  'A-END2'
]

export const inputNames = [
  'B-END',
  'A-END'
]

export const multiPointsTypes = {
  BUILDING: 'BTS',
  NOA: 'Node'
}

export const PUNTI_INTERMEDI_LABELS = {
  ROE: 'ROE',
  CNO: 'CNO/PFS',
  POZZETTO: 'POZZETTO'
}
export const PUNTI_INTERMEDI_KEYS = {
  'ROE': 'ROE',
  'CNO/PFS': 'CNO',
  'POZZETTO': 'POZZETTO'
}

export const POP_PCN_XPOP_LABELS = {
  POP: 'POP / PCN',
  PCN: 'PCN',
  XPOP: 'XPOP'
}
export const POP_PCN_XPOP_KEYS = {
  'POP / PCN': 'POP',
  'PCN': 'PCN',
  'XPOP': 'XPOP'
}